import ApiService from './api.service';

class CityService {
  async list() {
    try {
      const response = await ApiService.get('/city');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(cityData) {
    try {
      const response = await ApiService.post('/city/add', cityData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(cityData) {
    try {
      const response = await ApiService.put('/city/update', cityData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(cityId) {
    try {
      const response = await ApiService.delete('/city/delete', { id: cityId });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new CityService();